<template>
  <Popup v-bind="$attrs" round closeable :z-index="4000" class="d-f-warp">
    <div class="dialog-warp" :style="'height:' + dialog.height">
      <div class="d-cont-warp">
        <div class="dialog-title">请填写置业计划书</div>
        <div class="form-warp">
          <Form @submit="onSubmit" @failed="onFailed">
            <Field
              :border="false"
              v-model="state.name"
              class="input-class"
              name="name"
              label="姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名"
              placeholder="请填写姓名"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <Field
              :border="false"
              class="input-class"
              name="city"
              label="意向城市"
              placeholder="请输入意向城市"
              readonly
              arrow-direction="down"
              @click="handleSelectCity"
              :rules="[{ required: true, message: '请选择城市' }]"
              v-model="state.city"
            />
            <Field
              :border="false"
              v-if="state.city"
              class="input-class"
              readonly
              arrow-direction="down"
              name="districtval"
              label="意向区域"
              placeholder="点击选意向区域"
              v-model="state.district"
              @click="
                handelselectColumns('districtlist'),
                  handelselectState('district')
              "
              :rules="[{ required: true, message: '请选择区域' }]"
            />
            <Field
              :border="false"
              class="input-class"
              readonly
              name="housetypeval"
              arrow-direction="down"
              label="户&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型"
              v-model="state.houstypeval"
              placeholder="点击选择户型"
              @click="
                handelselectColumns('houstypelist'),
                  handelselectState('houstypeval')
              "
              :rules="[{ required: true, message: '请选择户型' }]"
            />
            <Field
              :border="false"
              class="input-class"
              readonly
              name="mianjival"
              arrow-direction="down"
              label="面&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;积"
              placeholder="点击选择面积"
              v-model="state.mianjival"
              @click="
                handelselectColumns('mianjilist'),
                  handelselectState('mianjival')
              "
              :rules="[{ required: true, message: '请选择面积' }]"
            />
            <Field
              :border="false"
              class="input-class"
              name="mobile"
              label="手&nbsp;&nbsp;机&nbsp;&nbsp;号"
              placeholder="请输入用手机号"
              :rules="[
                {
                  required: true,
                  message: '请输入手机号'
                },

                {
                  pattern: /^[1]([3-9])[0-9]{9}$/,
                  message: '手机号码格式错误！'
                }
              ]"
              v-model="state.mobile"
            />
            <Popup
              v-model:show="state.showPicker"
              position="bottom"
              teleport="body"
            >
              <Picker
                :columns="columns"
                @confirm="onConfirm"
                @cancel="state.showPicker = false"
                value-key="v"
              />
            </Popup>
            <div class="mobile-tips"
              >*手机号仅用于验证身份，已做加密处理，请放心填写</div
            >
            <div class="btn" :style="'padding-bottom:' + dialog.butpadding">
              <Button
                round
                block
                type="primary"
                native-type="submit"
                color="#d9001b"
                >生成报告</Button
              >
            </div>
          </Form>
        </div>
      </div>
    </div>
    <SelectCity
      url="?site=api&ctl=purchase&act=get_js_city"
      v-model:show="visibleCityPopup"
      v-model:currentCity="city"
      @change="citychange"
    />
  </Popup>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  reactive,
  shallowReactive,
  ref,
  toRefs,
  onUnmounted
} from 'vue'
import { Popup, Form, Field, Picker, Toast, Button } from 'vant'
import { request } from '@/utils/request'
import SelectCity from '@/components/SelectCity.vue'
import { useRouter, useRoute, LocationQueryValue } from 'vue-router'

interface State {
  city_en: string
  city: string
  name: string | LocationQueryValue[]
  mobile: string | LocationQueryValue[] | null
  mianjival: string
  district: string
  houstypeval: string
  mianji: number
  housetype: number
  showPicker: boolean
}
const getData = async (city: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get(
      '/?site=api&ctl=purchase&act=get_js_district&city_k=' + city
    )
    if (code == '0') {
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const choosecity = () => {
  const visibleCityPopup = ref(false)
  const city = '北京'
  return {
    city,
    handleSelectCity() {
      visibleCityPopup.value = true
    },
    visibleCityPopup
  }
}
const getlist = async () => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get('/?site=api&ctl=purchase&act=get_js_config')
    if (code == '0') {
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const Datafn = () => {
  const list = shallowReactive<{
    mianjilist: string[]
    houstypelist: string[]
    districtlist: string[]
  }>({
    mianjilist: [],
    houstypelist: [],
    districtlist: []
  })
  let columns = ref<Array<string>>([])
  const state = reactive<State>({
    city_en: '',
    city: '',
    name: '',
    mobile: '',
    mianjival: '',
    district: '',
    houstypeval: '',
    mianji: 0,
    housetype: 0,
    showPicker: false
  })

  const route = useRoute()
  onMounted(() => {
    if (route.query.name) {
      state.name = route.query.name
      state.mobile = route.query.mobile
    }
  })
  const citychange = async (value: { v: string; k: string }) => {
    if (state.city_en !== value.k) {
      const data = await getData(value.k)
      list.districtlist = []
      state.district = ''
      if (data) {
        list.districtlist = data
      }
    }
    state.city_en = value.k
    state.city = value.v
  }
  type ChooseType = keyof Omit<
    typeof state,
    'showPicker' | 'mianji' | 'housetype'
  >
  let choosetype = ref<ChooseType>('district')

  onMounted(async () => {
    const listdata = await getlist()
    if (listdata) {
      list.mianjilist = listdata.mianji
      list.houstypelist = listdata.housetype
    }
  })
  const router = useRouter()

  const onSubmit = async (values: Record<string, string>) => {
    values.city_en = state.city_en
    values.district = state.district
    values.housetype = String(state.housetype)
    values.mianji = String(state.mianji)
    try {
      const {
        data: { code }
      } = await request.get(
        '/?site=api&ctl=purchase&act=report&' +
          new URLSearchParams(values).toString()
      )
      if (code == '0') {
        if (route.path === '/detail') {
          router
            .replace({
              query: {
                city_en: values.city_en,
                district: values.district,
                mianji: values.mianji,
                housetype: values.housetype,
                name: values.name,
                mobile: values.mobile
              }
            })
            .then(() => {
              document.documentElement.scrollTop = 0
              window.location.reload()
            })
        } else {
          router.push({
            path: '/detail',
            query: {
              city_en: values.city_en,
              district: values.district,
              mianji: values.mianji,
              housetype: values.housetype,
              name: values.name,
              mobile: values.mobile
            }
          })
        }
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      Toast.fail('获取数据失败')
    }
  }
  const handelselectColumns = (type: keyof typeof list) => {
    columns.value = list[type]
  }
  const handelselectState = (type: ChooseType) => {
    choosetype.value = type
    state.showPicker = true
  }

  const onConfirm = (value: { v: string; k: string | number }) => {
    state[choosetype.value] = value.v
    if (choosetype.value === 'mianjival') {
      state.mianji = value.k as number
    } else if (choosetype.value === 'houstypeval') {
      state.housetype = value.k as number
    }
    state.showPicker = false
  }
  const onFailed = (values: any) => {
    Toast.fail(values.errors[0].message)
  }
  return {
    onFailed,
    onSubmit,
    citychange,
    onConfirm,
    columns,
    ...toRefs(list),
    handelselectColumns,
    handelselectState,
    state
  }
}

export default defineComponent({
  name: 'DiglogForm',
  components: {
    Popup,
    Picker,
    Form,
    Field,
    SelectCity,
    Button
  },
  setup() {
    const { city, handleSelectCity, visibleCityPopup } = choosecity()
    const oriHeight = document.documentElement.clientHeight
    const dialog = reactive({
      height: '',
      butpadding: ''
    })

    const resize = () => {
      const curH = document.documentElement.clientHeight
      if (
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Linux') > -1
      ) {
        if (curH !== oriHeight) {
          dialog.height = curH - 20 + 'px'
          dialog.butpadding = '20px'
        } else {
          dialog.height = ''
          dialog.butpadding = ''
        }
      }
    }
    onMounted(() => {
      window.addEventListener('resize', resize)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', resize)
    })
    return {
      dialog,
      ...Datafn(),
      handleSelectCity,
      visibleCityPopup,
      city
    }
  }
})
</script>

<style lang="scss" scoped>
:deep .input-class {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  font-weight: 400;
  color: #484848;
  padding: 0 0 2px;
  .van-cell__title {
    width: 64px;
  }
  .van-cell__value {
    background: #fafafa;
    padding-left: 16px;
  }
  .van-icon-arrow-down {
    margin: 0;
    color: #c4c4c6;
    background: #fafafa;
    padding-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}

:deep .van-button--round {
  border-radius: 4px;
}
.dialog-warp {
  width: 327px;
  padding: 0 24px 32px 24px;
  .d-cont-warp {
    width: 100%;
    height: 100%;
    padding-top: 48px;
    .dialog-title {
      height: 34px;
      font-size: 24px;
      font-weight: 600;
      color: #484848;
      line-height: 34px;
    }
    .form-warp {
      padding-top: 24px;
      .mobile-tips {
        position: absolute;
        margin-top: 8px;
        right: 38px;
        height: 11px;
        font-size: 8px;
        font-weight: 400;
        color: #d9001b;
        line-height: 11px;
      }
      .btn {
        margin-top: 51px;
        font-weight: 600;
      }
    }
  }
}
</style>
